import { Html5QrcodeScanner, Html5Qrcode } from "html5-qrcode";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Snackbars from "./Snackbars";

const QRScanner = () => {
  const [scannedResult, setScannedResult] = useState("");
  const [cameraId, setCameraId] = useState(null);

  const navigate = useNavigate();
  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: "",
  });
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: "",
        message: "",
      }));
    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
  };

  const [QrTimer, setQrTimer] = useState(0);

  const getSiteSettings = async () => {
  const headers = {
    "Content-Type": "application/json",
    "app-token": process.env.REACT_APP_TOKEN_SECRET,
  };
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}api/v1/scanner/getSiteSettings`,
      { headers: headers }
    );
    const res = response.data;

    if (res.code === 200) {
      if (res.data) {
        res.data.forEach(element => {
          if(element.setting_name == "qr_code_validity"){
            setQrTimer(element.setting_value);
          }
        });
      } else {
        setAlertData({
          variant: "error",
          message: res.message,
        });
        resetAlertData();
      }
    } else {
      setAlertData({
        variant: "error",
        message: res.message,
      });
      resetAlertData();
    }
  } catch (error) {
    setAlertData({
      variant: "error",
      message: "Something went Wrong.",
    });
    resetAlertData();
  }
}

  useEffect(() => {
    getSiteSettings();
    // Get available cameras
    Html5Qrcode.getCameras()
      .then((devices) => {
        if (devices.length > 0) {
          // Try to select the back camera (usually has 'back' in the label)
          const backCamera = devices.find((device) =>
            device.label.toLowerCase().includes("back")
          );
          setCameraId(backCamera ? backCamera.id : devices[0].id);
        }
      })
      .catch((err) => console.log("Camera fetch error:", err));
  }, []);

  useEffect(() => {
    if (!cameraId) return; // Wait until cameraId is available

    const scanner = new Html5QrcodeScanner("reader", {
      fps: 10,
      qrbox: { width: 250, height: 250 },
      aspectRatio: 1,
    });

    scanner.render(
      async (decodedText) => {
        console.log("Scanned QR Code:", decodedText);
        try {
          let data = JSON.parse(decodedText);

          if (data.qrcode_id) {
            
          const generateTime = new Date(data.generate_time);
          const currentTime = new Date();
          const timeDifferenceInMs = currentTime - generateTime;
          const timeDifferenceInMinutes = timeDifferenceInMs / (1000 * 60);

          if (timeDifferenceInMinutes <= QrTimer) {
            const headers = {
              "Content-Type": "application/json",
              "app-token": process.env.REACT_APP_TOKEN_SECRET,
            };
            try {
              const response = await axios.get(
                `${process.env.REACT_APP_API_URL}api/v1/scanner/ticket-details/${data.qrcode_id}`,
                { headers: headers }
              );
              const res = response.data;

              if (res.code === 200) {
                if (res.data) {
                  navigate(`/confirm-ticket/${data.qrcode_id}`);
                } else {
                  setAlertData({
                    variant: "error",
                    message: "Invalid QR Code",
                  });
                  resetAlertData();
                }
              } else {
                setAlertData({
                  variant: "error",
                  message: res.message,
                });
                resetAlertData();
              }
            } catch (error) {
              setAlertData({
                variant: "error",
                message: "Something went Wrong.",
              });
              resetAlertData();
            }
          } else {
            setAlertData({
              variant: "error",
              message: `QR code has expired (Older than ${QrTimer} minutes)`,
            });
            resetAlertData();
          }
          } else {
            setAlertData({
              variant: "error",
              message: "Invalid QR Code",
            });
            resetAlertData();
          }
        } catch (error) {
          setAlertData({
            variant: "error",
            message: "Invalid QR Code",
          });
          resetAlertData();
        }
        setScannedResult(decodedText);
      },
      (errorMessage) => {
        console.log("QR Scan failed:", errorMessage);
      }
    );


    const styleDropdown = () => {
      const selectElement = document.querySelector("#reader select");
      if (selectElement) {
        selectElement.style.marginBottom = "15px"; // Space below the dropdown
        selectElement.style.padding = "10px"; // Add padding
        selectElement.style.fontSize = "16px"; // Adjust font size
        selectElement.style.borderRadius = "5px"; // Rounded corners
        selectElement.style.border = "2px solid #000"; // Green border
        selectElement.style.backgroundColor = "#fff"; // White background
        selectElement.style.color = "#333"; // Dark text
        selectElement.style.cursor = "pointer";
        selectElement.style.width = "80%"; // Make it full width
        selectElement.style.maxWidth = "250px"; // Limit max width
        selectElement.style.textAlign = "center"; // Center text
        selectElement.style.boxShadow = "0px 4px 6px rgba(0, 0, 0, 0.1)"; // Light shadow
      }
    };
    
    // Observe changes and apply styles
    const observer1 = new MutationObserver(styleDropdown);
    const targetNode1 = document.getElementById("reader");
    
    if (targetNode1) {
      observer1.observe(targetNode1, { childList: true, subtree: true });
    }
    
    // Apply styles initially
    setTimeout(styleDropdown, 500);
    
    

    // Function to update button text and apply styles
    const updateButtonStyles = () => {
      const scanButton = document.querySelector("#reader button");
      if (scanButton) {
        if (scanButton.innerText.includes("Start Scanning")) {
          scanButton.innerText = "Scan Ticket";
        }
        scanButton.style.backgroundColor = "#28a745"; // Green color
        scanButton.style.color = "#fff"; // White text
        scanButton.style.border = "none";
        scanButton.style.padding = "10px 20px";
        scanButton.style.fontSize = "16px";
        scanButton.style.cursor = "pointer";
        scanButton.style.borderRadius = "5px";
      }

      // Style "Stop Scanning" button
      const stopButton = document.querySelector("#reader button:last-child");
      if (stopButton && stopButton.innerText.includes("Stop Scanning")) {
        stopButton.style.backgroundColor = "#dc3545"; // Red color
        stopButton.style.color = "#fff"; // White text
        stopButton.style.border = "none";
        stopButton.style.padding = "10px 20px";
        stopButton.style.fontSize = "16px";
        stopButton.style.cursor = "pointer";
        stopButton.style.borderRadius = "5px";
      }
    };

    // Create a MutationObserver to detect button changes
    const observer = new MutationObserver(updateButtonStyles);
    const targetNode = document.getElementById("reader");

    if (targetNode) {
      observer.observe(targetNode, { childList: true, subtree: true });
    }

    // Initial button text update
    setTimeout(updateButtonStyles, 500);

    return () => {
      scanner.clear();
      observer.disconnect(); // Stop observing when component unmounts
    };
  }, [cameraId, navigate]);

  return (
    <>
      {AlertData.message !== "" ? (
        <Snackbars variant={AlertData.variant} message={AlertData.message} />
      ) : (
        ""
      )}
      <div className="qr-container">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            textAlign: "center",
          }}
        >
          <h2>Ticket QR Code Scanner</h2>
          <div id="reader" style={{ width: "300px" }}></div>
        </div>
      </div>
    </>
  );
};

export default QRScanner;
